import { LoyaltyChallengeConfig } from '@shared/models';

import {
  BARCODE_FORMAT,
  DISPLAY_CONDITION,
  ProductCheckTabType,
  RewardFormat,
  ScanCheckMode,
  SubType,
  TitleType,
  Variants,
} from '../utils';

export const DEFAULT_CONFIG: LoyaltyChallengeConfig = {
  currency: 'EUR',
  currencyToRewardConversionRate: 1000,
  appIcon: 'assets/images/default/favicon.ico',
  cssVariables: {
    'font-family-bold': 'Montserrat-Bold',
    'font-family': "'Montserrat-Medium', sans-serif",

    'navbar-height': '65px',
    'navbar-background-color': '#ffffff',

    'nav-link-color': '#737373',
    'nav-link-hover-color': '#272F35',
    'nav-link-active-color': '#272F35',

    'nav-item-bg-color': 'white',
    'nav-item-active-bg-color': 'white',
    'nav-item-font-family': 'var(--font-family)',
    'nav-item-hover-bg-color': 'rgb(0 0 0 / 10%)',

    'body-color': '#000000',
    'body-background-color': '#ffffff',

    'challenge-primary-color': '#00529f',

    'tooltip-text-color': 'white',
    'tooltip-background-color': 'black',

    // Onboarding surface under the background artwork: royal blue matching
    // `onboarding-bg.webp`, so the white ink stays readable (WCAG AA) while
    // the image loads / if it fails. Without it the screens would fall back
    // to the light-grey header colour.
    'ob-surface': '#1233C7',
  },
  rewardFormat: RewardFormat.POINTS,
  og: {
    title: 'Current Challenges | Loyalty Challenge',
    description:
      "Discover the current challenges and earn up to 50€ by buying your favorite brands. Don't miss out on the opportunity to win big!",
  },
  rewardTemplate: '{points}<span style="font-size: 14px;">⭐️</span>',
  pages: {
    availablePages: ['soon', 'help', 'login', 'current', 'history'],
    help: {
      meta: {
        title: 'Current Challenges | Loyalty Challenge | Help Center',
        keywords:
          'loyalty, challenge, current, challenges, loyalty challenge, loyalty challenge current challenges',
        description:
          "Discover the current challenges and earn up to 50€ by buying your favorite brands. Don't miss out on the opportunity to win big!",
      },
      header: {
        background: '#00529f',
        goBackButton: {
          text: 'Go Back To My Challenges',
          backgroundColor: '#00529f',
          color: 'white',
          fontFamily: 'var(--font-family)',
          borderRadius: '60px',
        },
        bannerAlternativeText: '',
        howToPlay: {
          specificDisplayCondition: DISPLAY_CONDITION.ALWAYS,
          title: {
            color: 'white',
            text: 'Help Center',
            fontFamily: 'var(--font-family-bold)',
          },
        },
      },
      faqVariant: {
        variant: Variants.VARIANT_1,
        title: {
          displayWhenCampaignBis: false,
          label: 'Questions',
          type: TitleType.TEXT,
          styles: {
            color: '#272f35',
            fontSize: '16px',
            fontFamily: 'var(--font-family-bold)',
          },
        },
        questions: [
          {
            title: 'Modi tempora incidunt ut labore?',
            content:
              "<strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify <code>.accordion-body</code>, though the transition does limit overflow.",
          },
          {
            title: 'Modi tempora incidunt ut labore?',
            content:
              "<strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify <code>.accordion-body</code>, though the transition does limit overflow.",
          },
          {
            title: 'Modi tempora incidunt ut labore?',
            content:
              "<strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify <code>.accordion-body</code>, though the transition does limit overflow.",
          },
        ],
        accordion: {
          styles: {
            title: {},
            description: {},
          },
          alternativeTextExpandMore: '',
          alternativeTextExpandLess: '',
        },
      },
      extraLinks: [
        {
          title: {
            text: 'Need more help?',
            fontFamily: 'var(--font-family-bold)',
          },
          link: {
            color: 'white',
            label: 'Click here',
            fontFamily: 'var(--font-family)',
            backgroundColor: '#00529f',
            href: '',
          },
        },
      ],
    },
    currentChallenges: {
      meta: {
        title: 'Current Challenges | Loyalty Challenge',
        keywords:
          'loyalty, challenge, current, challenges, loyalty challenge, loyalty challenge current challenges',
        description:
          "Discover the current challenges and earn up to 50€ by buying your favorite brands. Don't miss out on the opportunity to win big!",
      },
      background: 'white',
      howDoesitWork: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
        backgroundColor: '#00529f',
        containerBackgroundColor: 'white',
        text: 'How it Works',
        borderRadius: '60px',
        containerPadding: '2rem 0 0',
        modal: {
          background: '#FFFFFF',
          title: {
            text: 'How it Works',
            color: '#000000',
            fontFamily: 'var(--font-family-bold)',
          },
          closeButton: {
            imageUrl: 'assets/images/default/close-button.svg',
            alternativeText: 'Fermer le tutoriel',
            color: 'var(--challenge-primary-color)',
          },
          skipNowButton: {
            text: "Passer pour l'instant",
            color: 'white',
            fontFamily: 'var(--font-family-bold)',
            backgroundColor: '#00529f',
            borderRadius: '60px',
          },
        },
      },
      howToPlay: {
        specificDisplayCondition: DISPLAY_CONDITION.DEFAULT,
      },
    },
    pastChallenges: {
      meta: {
        title: 'Loyalty Challenge | Past Challenges',
        keywords:
          'loyalty, challenge, current, challenges, loyalty challenge, loyalty challenge, past challenges',
        description:
          "Discover the current challenges and earn up to 50€ by buying your favorite brands. Don't miss out on the opportunity to win big!",
      },
      banner: {
        visibility: true,
        title: 'Past Challenges',
        background: '#F2F2F2',
        bannerAriaLabel: '',
        styles: {
          title: {
            margin: 'unset',
            color: '#272F35',
            fontSize: '27px',
            fontFamily: 'var(--font-family-bold)',
          },
          banner: {
            height: '170px',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '2rem',
            justifyContent: 'center',
          },
        },
      },
      accordion: {
        variant: Variants.VARIANT_2,
        alternativeTextExpandMore: '',
        alternativeTextExpandLess: '',
        date: {
          color: 'black',
          format: 'd MMMM',
          fontFamily: 'var(--font-family)',
          template: 'Du {startDate} au {endDate}',
        },
        reward: {
          color: 'white',
          borderRadius: '5px',
          backgroundColor: '#00529f',
          fontFamily: 'var(--font-family-bold)',
        },
      },
      noChallengesText: {
        color: 'black',
        fontFamily: 'var(--font-family)',
        text: 'No selected challenges',
      },
      noRewardsText: {
        color: 'black',
        fontFamily: 'var(--font-family)',
        text: 'No rewards earned',
      },
    },
    futureChallenges: {
      meta: {
        title: 'Loyalty Challenge | Future Challenges',
        keywords:
          'loyalty, challenge, challenges, loyalty challenge, future challenges',
        description:
          "Discover the current challenges and earn up to 50€ by buying your favorite brands. Don't miss out on the opportunity to win big!",
      },
      banner: {
        visibility: true,
        title: 'Coming Soon',
        campaignInfo: {
          template: '{firstDate} - {lastDate}',
          dateFormat: 'MMMM d',
        },
        background: '#F2F2F2',
        styles: {
          title: {
            color: '#272F35',
            fontSize: '27px',
            fontFamily: 'var(--font-family-bold)',
          },
          date: {},
          banner: {
            height: '170px',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '2rem',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        },
      },
    },
    sorry: {
      background: '#F2F2F2',
      content: [
        '<div style="max-width: 200px; margin: 0 auto 1rem;"><img src="assets/images/default/logo.svg" alt=""></div>',
        '<div style="font-size: 1.5rem; text-align: center; color: black; font-family: var(--font-family);">Oops!</div>',
        '<div style="font-size: 1.2rem; text-align: center; color: black; font-family: var(--font-family);">The challenges are available only to the customers who have received an email.</div>',
      ],
    },
    authPage: {
      variant: Variants.VARIANT_3,
      meta: {
        title: 'Current Challenges | Loyalty Challenge',
        keywords:
          'loyalty, challenge, current, challenges, loyalty challenge, loyalty challenge current challenges',
        description:
          "Discover the current challenges and earn up to 50€ by buying your favorite brands. Don't miss out on the opportunity to win big!",
      },
      header: {
        backgroundColor: 'white',
        backgroundImage: {
          mobile: '',
          tablet: '',
          desktop: '',
        },
        logo: 'assets/images/default/logo.svg',
        logoWidth: '235px',
        labels: [
          {
            text: 'Earn up to',
            size: 'big',
            font: 'var(--font-family-bold)',
          },
          {
            text: '50€',
            size: 'big',
            font: 'var(--font-family-bold)',
          },
          {
            text: 'buying your favorite brands',
            size: 'big',
            font: 'var(--font-family-bold)',
          },
        ],
        errorMessage:
          "Votre compte n'a pas été trouvé. Quelques jours peuvent être nécessaires pour pouvoir se connecter après la création d'une carte.",
        signinBloc: {
          backgroundColor: '#00529f',
          title: {
            color: 'white',
            label: 'Inscrivez-vous pour jouer',
            fontFamily: 'var(--font-family-bold)',
          },
          form: {
            fields: [
              {
                type: 'select',
                placeholder: '',
                defaultValue: 'phone_number',
                formControlName: 'info_type',
                label: 'Quel numéro utilisez-vous ? ',
                validations: [
                  {
                    type: 'required',
                    message: 'Ce champ est obligatoire',
                  },
                ],
                options: [
                  {
                    value: 'phone_number',
                    label: 'Numéro de téléphone du programme fidélité',
                  },
                  {
                    value: 'card_number',
                    label: 'Numéro de compte du programme fidélité',
                  },
                ],
                fieldStyles: {
                  color: 'white',
                  height: '40px',
                  fontSize: '13px',
                  backgroundColor: 'transparent',
                  backgroundImage:
                    "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\")",
                },
              },
              {
                type: 'text',
                group: false,
                formControlName: 'phone_number',
                placeholder: '(305) 453-1600 *',
                label:
                  'Numéro de téléphone que vous utilisez pour vous identifier en magasin',
                validations: [
                  {
                    type: 'required',
                    message: 'Ce champ est obligatoire',
                  },
                ],
              },
              {
                group: false,
                type: 'number',
                placeholder: 'xxxxxxxxxxx',
                formControlName: 'card_number',
                label: 'Numéro de compte',
                validations: [
                  {
                    type: 'pattern',
                    pattern: '.{10}[0-9]|.{15}[0-9]',
                    message: 'Le numéro que vous avez saisi est invalide',
                  },
                ],
              },
            ],
            additionalFields: [
              {
                validations: [],
                type: 'checkbox',
                placeholder: 'Se souvenir de moi',
                formControlName: 'lc_optin',
                labelStyles: {
                  color: 'white',
                  fontSize: '12px',
                  fontFamily: 'var(--font-family)',
                },
              },
            ],
            submitButton: {
              color: 'white',
              label: 'Se connecter',
              backgroundColor: '#3e7ba4',
              fontFamily: 'var(--font-family-bold)',
            },
          },
          signupLabel: 'Vous n’avez pas encore de compte fidélité ?',
          linkToCard: {
            color: 'white',
            label: 'Inscrivez-vous maintenant',
            fontFamily: 'var(--font-family)',
            url: '',
          },
        },
      },
      howToPlay: {
        title: {
          color: 'white',
          text: 'Comment ça marche ?*',
          fontFamily: 'var(--font-family-bold)',
        },
        specificDisplayCondition: DISPLAY_CONDITION.ALWAYS,
        templateHowToPlay: {
          mobile: [
            '<div style="text-align: center; color: white;font-family: var(--font-family-medium); font-size: 15px;"> *See <a href="{variable}" style="font-family: var(--font-family-bold); color: white; text-decoration: underline">FAQ</a> to see more details on how to play</div>',
          ],
          tablet: [
            '<div style="text-align: center; color: white;font-family: var(--font-family-medium); font-size: 15px;"> *See <a href="{variable}" style="font-family: var(--font-family-bold); color: white; text-decoration: underline">FAQ</a> to see more details on how to play</div>',
          ],
          desktop: [
            '<div style="text-align: center; color: white; font-family: var(--font-family-medium); font-size: 15px;"> *See <a href="{variable}" style="font-family: var(--font-family-bold); color: white; text-decoration: underline">FAQ</a> to see more details on how to play</div>',
          ],
        },
      },
    },
  },
  components: {
    onboarding: {
      dialogLabel: 'Onboarding',
      closeLabel: 'Close onboarding',
      // Reuse the retailer header promise ("Earn up to 50€") on the welcome screen.
      showHeaderPromise: true,
      // Round promise vignette colours (gold fill + vivid royal-blue ink).
      vignette: {
        backgroundColor: '#ffce00',
        textColor: '#1e3fb8',
      },
      // Solid royal-blue backdrop for the immersive screens (welcome / swipe / match).
      background: {
        mobile: {
          imageUrl: 'assets/images/default/onboarding-bg.webp',
        },
        tablet: {
          imageUrl: 'assets/images/default/onboarding-bg.webp',
        },
        desktop: {
          imageUrl: 'assets/images/default/onboarding-bg.webp',
        },
      },
      welcome: {
        title: 'Earn even more on the products you love.',
        lead: 'Discover the challenges just picked for you.',
        startLabel: 'Discover my challenges',
        image: {
          imageUrl: 'assets/images/default/onboarding-hero.webp',
          alternativeText: 'Amazing Challenges',
        },
        stepsBadge: {
          // The badge artwork is the disc here, so the plain one stays out of
          // the way.
          backgroundColor: 'transparent',
          textColor: '#232323',
          image: {
            imageUrl: 'assets/images/default/onboarding-badge.svg',
          },
        },
        steps: [
          {
            label: 'Shop',
            sublabel: 'your products',
            image: {
              imageUrl: 'assets/images/default/onboarding-shop.webp',
              alternativeText: 'A basket full of groceries',
            },
          },
          {
            label: 'Pay',
            sublabel: 'with your card',
            image: {
              imageUrl: 'assets/images/default/onboarding-pay.webp',
              alternativeText: 'Paying with a card on your phone',
            },
          },
          {
            label: 'Earn',
            sublabel: 'rewards',
            image: {
              imageUrl: 'assets/images/default/onboarding-earn.webp',
              alternativeText: 'Collect your loyalty rewards',
            },
          },
        ],
      },
      swipe: {
        title: 'Crush!',
        titleImage: {
          imageUrl: 'assets/images/default/onboarding-crush.webp',
          alternativeText: 'Crush!',
        },
        subtitle: 'Select your favorite challenges!',
        hint: 'Swipe left to pass. Swipe right to get it.',
        passLabel: 'Pass',
        selectLabel: 'I love it',
        toast: {
          title: "It's a match!",
          body: 'Added to your challenges.',
        },
        counter: {
          selectedTemplate: '{n} / {max} selected',
          remainingTemplate: '{n} picks left',
          remainingSingularTemplate: '{n} pick left',
        },
        allChallengesLabel: 'See all challenges',
      },
    },
    header: {
      variant: Variants.VARIANT_5,
      backgroundColor: '#F2F2F2',
      bannerAriaLabel: '',
      date: {
        color: '#00529f',
        fontFamily: 'var(--font-family-medium)',
        label: 'Loyalty Challenges ends in {variable}',
      },
      promiseTemplateBackgroundColor: 'rgb(36, 116, 190)',
      promiseTemplate: [
        {
          color: 'white',
          label: 'Earn up to',
          class: 'first-label',
          fontFamily: 'var(--font-family-bold)',
        },
        {
          label: '50€',
          color: 'white',
          class: 'second-label',
          fontFamily: 'var(--font-family-bold)',
        },
        {
          color: 'white',
          label: 'buying your favorite brands',
          class: 'third-label',
          fontFamily: 'var(--font-family-bold)',
        },
      ],
      picture: {
        imageUrl: 'assets/images/default/logo.svg',
        alternativeText: '',
      },
    },
    brands: {
      variant: Variants.VARIANT_1,
      brandsBgColor: 'white',
      border: '2px solid #00529f',
      alternativeText: '',
    },
    footer: {
      variant: Variants.VARIANT_1,
      mobileVisiblity: true,
      styles: {
        display: 'flex',
        padding: '30px 0',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        borderTop: '1px solid #f4f5f6',
      },
      linkStyles: {
        color: '#272f35',
        fontSize: '16px',
        textDecoration: 'none',
        fontFamily: 'var(--font-family)',
      },
      links: [
        {
          url: 'help',
          label: 'Help Center',
        },
      ],
    },
    tutorial: {
      background: '#00529f',
      carousel: {
        config: {
          sectionAriaLabel: 'Tutorial carousel',
          controlsAriaLabel: 'Carousel controls',
          paginationAriaLabel: 'Slide indicators',
          dots: {
            inactiveBg: '#FFFFFF80',
            activeBg: '#FFFFFF',
            ariaLabel: 'Go to slide {variable} of {variable}',
          },
          slideIndicatorLabel: 'Slide {variable} on {variable}',
          controls: {
            leftIcon: {
              imageUrl: 'assets/images/default/chevron-left.svg',
              alternativeText: 'Go to the previous slide',
            },
            rightIcon: {
              imageUrl: 'assets/images/default/chevron-right.svg',
              alternativeText: 'Go to the next slide',
            },
          },
        },
        items: {
          variant: Variants.VARIANT_2,
          styles: {
            description: {
              color: '#737373',
              fontFamily: 'var(--font-family)',
            },
            card: {
              border: 'none',
              background: 'white',
              borderRadius: '16px',
              boxShadow: '0px 4.269px 15.61px 0px rgba(38, 38, 38, 0.15)',
            },
          },
          steps: [
            {
              description: 'parmi les 20 qui vous sont proposés',
              picture: {
                alternativeText: '',
                imageUrl: 'assets/images/default/logo.svg',
              },
            },
            {
              description: 'Présentez votre carte de fidélité.',
              picture: {
                alternativeText: '',
                imageUrl: 'assets/images/default/logo.svg',
              },
            },
            {
              description: 'en avantages carte',
              picture: {
                imageUrl: 'assets/images/default/logo.svg',
                alternativeText: '',
              },
            },
          ],
        },
      },
    },
    wallet: {
      variant: Variants.VARIANT_2,
      backgroundColor: '#00529f',
      label: {
        color: 'white',
        fontSize: '16px',
        text: 'My Wallet',
        fontFamily: 'var(--font-family)',
        lineHeight: '28px',
      },
      amount: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
      },
    },
    navbar: {
      variant: Variants.VARIANT_2,
      menuVariant: Variants.VARIANT_2,
      hasLayoutPaddingTop: true,
      dropdownLabel: 'Menu',
      openButton: {
        imageUrl: 'assets/images/default/menu.svg',
        buttonTitle: '',
        imageAlt: '',
      },
      fontFamily: 'var(--font-family)',
      logo: {
        url: 'current',
        height: '35px',
        imageUrl: 'assets/images/default/logo.svg',
        alternativeText: '',
      },
      items: [
        {
          url: 'current',
          label: 'Home',
          ariaLabel: '',
        },
        {
          url: 'history',
          label: 'History',
          ariaLabel: '',
        },
        {
          url: 'soon',
          label: 'Soon',
          ariaLabel: '',
        },
        {
          url: 'help',
          label: 'Help',
          ariaLabel: '',
        },
      ],
    },
    countdown: {
      variant: Variants.VARIANT_1,
      showOnNavbarWhen: [],
      showAfterCampaignSummaryWhen: [],
      showBeforeCampaignSummaryWhen: [],
      showOnPages: 'all',
      titleAppearing: ['column', 'column', 'column'],
      titleVerticalAlignment: ['center', 'center', 'center'],
      labelStyle: {
        color: '#272F35',
        fontFamily: 'var(--font-family)',
      },
      title: {
        color: '#272F35',
        showTitleOnMobile: true,
        fontFamily: 'var(--font-family)',
        label: 'End of the game in {variable}!',
      },
      numberStyle: {
        color: 'white',
        backgroundColor: '#00529f',
        fontFamily: 'var(--font-family)',
      },
      texts: {
        days: 'DAYS',
        hours: 'HOURS',
        minutes: 'MINUTES',
        seconds: 'SECONDS',
      },
    },
    challenges: {
      elements: {
        winCard: {
          variant: Variants.VARIANT_6,
          backgroundColor: '#FFFFFF',
          label: {
            color: '#000000',
            text: 'Congratulations !',
            fontFamily: 'var(--font-family-bold)',
          },
          reward: {
            label: {
              text: ' You won ! ',
              color: '#000000',
              fontFamily: 'var(--font-family)',
            },
            amount: {
              color: 'white',
              alternativeText: '',
              backgroundColor: '#00529f',
              fontFamily: 'var(--font-family)',
              icon: '',
            },
          },
        },

        selectionButton: {
          variant: Variants.VARIANT_1,
          catchPhrase: {
            amountBackgroundColor: '#00529f',
            imageUrl: 'assets/images/default/selection-rec.svg',
            alternativeText: 'Earn up to {variable} points',
            amountLabel: 'Earn up to',
            lineHeight: '22px',
          },
          buttonCatchPhrase: {
            buttonAmountFontFamily: 'var(--font-family)',
            buttonAmountLabel: 'Start this challenge',
            buttonAmountBackgroundColor: '#00529f',
            borderRadius: '60px',
          },
        },
        unselectionButton: {
          variant: Variants.VARIANT_1,
          icon: {
            imageUrl: 'assets/images/default/cancel.svg',
            alternativeText: '',
          },
        },
        outOfStock: {
          variant: Variants.VARIANT_1,
          backgroundColor: 'rgba(15, 50, 80, 0.65)',
          borderRadius: '16px',
          banner: {
            border: '2px solid white',
            textColor: 'white',
            borderRadius: '2px',
            backgroundColor: '#DB3832',
            text: 'No more challenges',
            fontFamily: 'var(--font-family-bold)',
          },
        },
      },
      step: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_1,
          header: {
            height: '143px',
            backgroundColor: '#FFFFFF',
            backgroundImage: 'assets/images/default/step-header-bg.webp',
          },
          subHeader: {
            color: 'black',
            backgroundColor: 'white',
            completedBackgroundColor: 'white',
            fontFamily: 'var(--font-family)',
            fontSize: '10px',
            icon: {
              title: 'Informations',
              imageUrl: 'assets/images/default/barcode.svg',
              alternativeText: '',
            },
          },
          body: {
            progressbar: {
              earnLabel: 'Earn',
              spendLabel: 'Spend',
              containerColor: '#ccc',
              progressColor: '#1c7eff',
              pictureStageReached: 'assets/images/default/present.svg',
            },
            rewardPastille: {
              label: 'Earn',
              hasPicto: false,
              defaultStyles: {
                color: 'black',
                fontFamily: 'var(--font-family-bold)',
              },
            },
            rewards: {
              color: 'black',
              fontFamily: 'var(--font-family-bold)',
            },
            targets: {
              color: 'black',
              fontFamily: 'var(--font-family-bold)',
            },
          },
          footer: {
            color: 'black',
            label: "You've spent",
            fontFamily: 'var(--font-family-bold)',
            icon: 'assets/images/default/shop.svg',
            spentAmount: { fontFamily: 'var(--font-family-bold)' },
          },
        },
      },
      frequency: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_1,
          boxShadow: 'rgba(38, 38, 38, 0.08) 0px 4px 24px',
          header: {
            backgroundImage: {
              url: 'assets/images/default/frequency-banner.webp',
              bannerAriaLabel: 'Frequency Challenge Banner',
            },
            height: '143px',
          },
          subHeader: {
            borderBottom: '1px solid #f4f5f6',
            backgroundColor: 'white',
            completedBackgroundColor: 'white',
            title: {
              color: 'black',
              label: 'Store visits from {variable}€',
              fontFamily: 'var(--font-family)',
            },
          },
          body: {
            label: 'Complete {variable} store visits to unlock your reward',
            labelFontFamily: 'var(--font-family-bold)',
            labelFontSize: '14px',
            stamps: {
              showNumbers: false,
              iconSelected: 'assets/images/default/frequency-stamp-success.svg',
              iconNonSelected:
                'assets/images/default/frequency-stamp-empty.svg',
            },
          },
          footer: {
            color: 'black',
            label: 'Visits: ',
            fontFamily: 'var(--font-family)',
            footerIcon: {
              imageUrl: 'assets/images/default/shop.svg',
              alternativeText: '',
            },
          },
        },
      },
    },
    challengeSummary: {
      variant: Variants.VARIANT_1,
      stackOnMobile: false,
      title: {
        color: 'black',
        text: 'Your challenges',
        fontFamily: 'var(--font-family-bold)',
        transform: 'none',
      },
      challengeLabels: {
        onGoingLabel: {
          color: '#333333',
          text: 'Ongoing',
          fontFamily: 'var(--font-family)',
        },
        completedLabel: {
          color: '#333333',
          text: 'Completed',
          fontFamily: 'var(--font-family)',
        },
      },
      counterBorderRadius: '5px',
      challengesInfos: {
        color: 'white',
        backgroundColor: '#00529f',
        fontFamily: 'var(--font-family)',
      },
    },
    modals: {
      closeButton: {
        label: 'Close',
        textColor: 'white',
        borderRadius: '50px',
        backgroundColor: 'var(--challenge-primary-color)',
        fontFamily: 'var(--font-family-bold)',
        ariaLabel: '',
      },
      unselectChallenge: {
        backgroundColor: '#FFFFFF',
        header: {
          backgroundColor: '',
          backgroundImage: '',
        },
        frequencyHeaderImages: {
          [SubType.DEFAULT]: {
            imageUrl: 'assets/images/default/frequency-header.webp',
            alternativeText: '',
          },
        },
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Are you sure you want to<br/> unselect this challenge?',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'No worries, if you regret it<br/> you can select this challenge again!',
        },

        actionButtons: {
          variant: Variants.VARIANT_1,
          confirmButton: {
            label: 'Confirm',
            borderRadius: '50px',
            textColor: '#FFFFFF',
            backgroundColor: '#00529f',
            fontFamily: 'var(--font-family-bold)',
            ariaLabel: '',
          },
          closeButton: {
            label: 'Cancel',
            borderRadius: '50px',
            textColor: 'white',
            backgroundColor: '#00529f',
            fontFamily: 'var(--font-family-bold)',
            ariaLabel: '',
          },
        },
      },
      productCheck: {
        ariaLabel: '',
        backgroundColor: '#FFFFFF',
        fontFamily: 'var(--font-family)',
        tabs: [
          {
            type: ProductCheckTabType.SCAN,
            checkMode: ScanCheckMode.PRODUCT_LIST,
            label: 'Scan',
            title: 'Barcode Verification',
            readers: [BARCODE_FORMAT.EAN_8, BARCODE_FORMAT.EAN_13],
            successMessage: 'Success',
            errorMessage: 'NOT ELIGIBLE FOR THIS GAME',
            startButtonLabel: 'Start scanner',
            retryPermissionButtonLabel: 'Retry camera access',
            failureMessage: 'AN ERROR OCCURRED, PLEASE TRY AGAIN',
            restartButtonLabel: 'Restart Scan',
            errorWhenCameraPermissionDenied:
              'Please allow camera access to use the scanner.',
            errorWhenCameraNotFound: 'Camera not available',
            errorWhenCameraBusy:
              'The camera is in use by another app. Close it, then try again.',
            previewLabel: 'Barcode scanner preview',
            subtitle: 'Scan your product here',
          },
          {
            type: ProductCheckTabType.PRODUCT_LIST,
            failureMessage: 'AN ERROR OCCURRED, PLEASE TRY AGAIN',
            label: 'Enter manually',
            searchable: true,
            inputPlaceholder: 'Enter a barcode to search',
            columns: {
              name: {
                header: 'Product',
                color: '',
                fontFamily: 'var(--font-family-light)',
              },
              code: {
                header: 'Barcode',
                color: '',
                fontFamily: 'var(--font-family-light)',
              },
            },
          },
        ],
        tabConfig: {
          activeColor: 'white',
          inactiveColor: 'black',
          inactiveBackground: 'white',
          fontFamily: 'var(--font-family)',
          inactiveBorderBottom: '2px solid #e6e6e6',
          activeBackground: 'var(--challenge-primary-color)',
          activeBorderBottom: '2px solid var(--challenge-primary-color)',
        },
      },
      firstSelection: {
        backgroundColor: 'white',
        title: {
          color: '#272f35',
          label: '1st challenge activated',
          fontFamily: 'var(--font-family-bold)',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Congratulations! you just selected<br/> your first challenge!',
        },
      },
      lastSelection: {
        backgroundColor: 'white',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: '{variable} challenges activated',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            "Well done ! you've activated<br/> your {variable} favorite challenges",
        },
      },
      maximumSelection: {
        backgroundColor: 'white',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: "Sorry, you've already activated {variable} challenges",
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'No worries, if you want to select another challenge you can unselect one of the challenges you haven’t started yet.',
        },
      },
      eventDialog: {
        scratchTicket: {
          title: {
            color: 'black',
            fontFamily: 'var(--font-family)',
            label: 'Welcome to Loyalty Challenge',
          },
          subTitle: {
            color: 'black',
            fontFamily: 'var(--font-family)',
            label: 'Scratch this card to reveal your reward !',
          },
          body: {
            color: '#55636b',
            fontFamily: 'var(--font-family)',
            label:
              'Scratch Game rewards will be added to your account within 48 hours.',
          },
          reward: {
            color: 'black',
            rewardLabel: 'You won',
            rewardPoints: '',
            fontFamily: 'var(--font-family)',
            winIcon: 'assets/images/default/scratch-win.webp',
          },
          closeButton: {
            textColor: 'white',
            fontFamily: 'var(--font-family-bold)',
            label: 'Back to Challenges',
            backgroundColor: 'var(--challenge-primary-color)',
            ariaLabel: '',
            borderRadius: '80px',
            borderColor: 'unset',
          },
          canvasMask: '#FFCD00',
          canvasMaskType: 'color',
          headerBackgroundImage: '',
          logo: 'assets/images/default/logo.svg',
        },
      },
      outOfStockIssue: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Limite atteinte',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Ce challenge a atteint le nombre maximal de participants. Veuillez en choisir un autre.',
        },
      },
      genericError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Error',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            "An error occurred, and the challenge couldn't be selected. Please check your connection and try again.",
        },
      },
      timeoutError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Request timed out',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Selecting the challenge took too long. Please check your connection and try again.',
        },
      },
      challengeUnavailable: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Campaign ended',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'This campaign has ended and challenges are no longer available for selection.',
        },
      },
    },
  },
};
